import { Box, Drawer, Divider, useMediaQuery, useTheme } from "@mui/material";
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import Config from "@/config.json";
import { useMemo } from "react";
import IMenuDrawerProps from "@/interfaces/Props/IMenuDrawerProps";
import MiniDrawerStyled from "./MiniDrawerStyled";

const MainDrawer = ({ open, handleDrawerToggle, window }: IMenuDrawerProps) => {

    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

    // responsive drawer container
    const container = window !== undefined ? () => window().document.body : undefined;

    const drawerHeader = useMemo(() => <DrawerHeader open={open} />, [open]);
    const drawerContent = useMemo(() => <DrawerContent />, []);


    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1300 }} >
            {!matchDownMD ? (
                <MiniDrawerStyled theme={theme} variant="permanent" open={open} >
                    {drawerHeader}
                    <Divider sx={{ bgcolor: "#FFFFFF" }} />
                    {drawerContent}
                </MiniDrawerStyled>
            ) : (
                <Drawer
                    container={container}
                    variant="temporary"
                    open={open}
                    onClose={handleDrawerToggle}
                    ModalProps={{ keepMounted: true }}
                    sx={{
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: Config.drawerWidth,
                            borderRight: `1px solid ${theme.palette.divider}`,
                            backgroundColor: `${theme.palette.primary.main}`,
                            boxShadow: 'inherit'
                        }
                    }}
                >
                    {open && drawerHeader}
                    <Divider sx={{ bgcolor: "#FFFFFF" }} />
                    {open && drawerContent}
                </Drawer>
            )}
        </Box>
    )
}


export default MainDrawer;